import {
  ColorPicker,
  FieldColorPicker,
  FieldColorPickerProps,
} from '@dixa/lib-shared-habla';

interface ColorInputFieldProps extends FieldColorPickerProps {
  presetColors: string[];
}
export function ColorInputField(props: ColorInputFieldProps) {
  return (
    <FieldColorPicker {...props}>
      <ColorPicker.Sliders />
      <ColorPicker.Presets presets={props.presetColors} />
      <ColorPicker.Input />
    </FieldColorPicker>
  );
}
